import React from "react";

const JobFilterContext = React.createContext('');

export default JobFilterContext;